/**
 * @brandOverride URBNWeb
 */
import { sizeGuideReducer } from './sizeGuideReducer';

export function getProductSubReducers(existingSubReducers) {
    return _.concat(existingSubReducers, sizeGuideReducer);
}

